<script setup lang="ts">
import { usePwa } from '@/composables/use-pwa.ts';
import VenneventWordmark from '@/components/branding/VenneventWordmark.vue';

const pwa = usePwa();

function retry() {
  window.location.reload();
}

function formatLastSync(timestamp: number) {
  if (!timestamp) return 'No saved content timestamp is available.';
  return `Last refreshed ${new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' }).format(timestamp)}.`;
}
</script>

<template>
  <aside
    v-if="!pwa.isOnline.value || pwa.updateAvailable.value || pwa.canInstall.value"
    class="pointer-events-none fixed inset-x-0 top-2 z-[9999] flex justify-center px-3"
    aria-live="polite"
  >
    <div class="bg-base-100 rounded-box pointer-events-auto flex max-w-xl flex-wrap items-center justify-center gap-2 border p-2 shadow-lg">
      <template v-if="!pwa.isOnline.value">
        <icon icon="material-symbols:cloud-off-outline" />
        <span class="text-sm">Offline — saved content is read-only. {{ formatLastSync(pwa.lastContentSync.value) }}</span>
        <button
          class="btn btn-primary btn-xs"
          type="button"
          @click="retry"
        >
          Retry
        </button>
      </template>
      <template v-else-if="pwa.updateAvailable.value">
        <span class="text-sm">A Vennevent update is ready.</span>
        <button
          class="btn btn-primary btn-xs"
          type="button"
          @click="pwa.applyUpdate"
        >
          Update
        </button>
      </template>
      <template v-else>
        <VenneventWordmark size="small" />
        <span class="text-sm">Install Vennevent for quicker access.</span>
        <button
          class="btn btn-primary btn-xs"
          type="button"
          @click="pwa.install"
        >
          Install
        </button>
        <button
          class="btn btn-ghost btn-xs"
          type="button"
          @click="pwa.dismissInstall"
        >
          Not now
        </button>
      </template>
    </div>
  </aside>
</template>
